export default {
  name: 'image',
  imageList: 'imageList'
};
